module.exports = __webpack_public_path__ + "static/media/trenitalia-bg.2dabcb79.jpg";